import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { updateProjectSettings } from '@/store/slices/project';
import { getWorkingProject } from '@/store/slices/project/selectors';
import { EventSettings } from '@/types/projects.types';
import useCanUseChannelFeature from '@/utils/use-can-use-channel-features';
import OptionalComponent from '@ui/optional-component/optional-component';
import { ChannelFeaturesEnum } from '@/types/feature-flags.types';
import SettingsToggle from '../../controls/settings-toggle';
import CourseMain from './course-main';

const CoursesSettings = () => {
  const dispatch = useAppDispatch();
  const workingProject = useAppSelector(getWorkingProject);

  const coursesEnabled = !!workingProject?.settings.course_enabled;

  const canUseCourses = useCanUseChannelFeature(ChannelFeaturesEnum.courses);

  const toggleCourses = (sKey: string, on: boolean) => {
    if (!workingProject) return null;

    const projectSettings: EventSettings = {
      ...workingProject.settings,
      course_enabled: on,
    };
    dispatch(updateProjectSettings({ event_uuid: workingProject.uuid, settings: projectSettings }));
  };

  return (
    <>
      <OptionalComponent display={canUseCourses && !coursesEnabled}>
        <SettingsToggle label="Attendee Course" value={coursesEnabled} sKey="enable_course" onToggle={toggleCourses} />
      </OptionalComponent>
      <OptionalComponent display={coursesEnabled}>
        <CourseMain />
      </OptionalComponent>
    </>
  );
};

export default CoursesSettings;
